import CaseDraftsContainer from './CaseDraftsContainer';

export default CaseDraftsContainer;
